export enum checkboxStatuses {
    unchecked = 'unchecked',
    indeterminate = 'indeterminate',
    checked = 'checked',
}
